import { render, staticRenderFns } from "./BaseDataTableSection.vue?vue&type=template&id=734aad4c"
import script from "./BaseDataTableSection.vue?vue&type=script&lang=js"
export * from "./BaseDataTableSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports